import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import ProvaSocial from './components/ProvaSocial';
import Beneficios from './components/Beneficios';
import Comparativo from './components/Comparativo';
import OfertaCta from './components/OfertaCta';
import Footer from './components/Footer';

const GA_EVENT = (name: string) => {
  if (typeof window !== 'undefined' && (window as unknown as Record<string, unknown>).gtag) {
    (window as unknown as Record<string, (...args: unknown[]) => void>).gtag('event', name, {
      event_category: 'conversion',
      event_label: 'landing-sacada-sp',
    });
  }
};

export default function LandingSacadaSP() {
  useEffect(() => {
    document.title = 'Orçamento Grátis Fechamento Sacada SP | Vidros Thelux';
    
    // Canonical dinâmico
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = 'https://vidrosthelux.com.br/fechamento-sacada-sp';
    
    // OG Image
    let ogImage = document.querySelector('meta[property="og:image"]') as HTMLMetaElement | null;
    if (!ogImage) {
      ogImage = document.createElement('meta');
      ogImage.setAttribute('property', 'og:image');
      document.head.appendChild(ogImage);
    }
    ogImage.content = 'https://readdy.ai/api/search-image?query=modern%20apartment%20balcony%20with%20frameless%20glass%20enclosure%20S%C3%A3o%20Paulo%20city%20view%20sunset%20warm%20golden%20light%20residential%20architecture%20premium%20lifestyle&width=1200&height=630&seq=og-landing-001&orientation=landscape';
    
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute(
        'content',
        'Fechamento de sacada articulada sem roldana em São Paulo. Vidro temperado certificado, NBR 7199. Orçamento grátis via WhatsApp em 15 minutos. Atendemos todos os bairros de SP e Grande SP.'
      );
    }
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute(
        'content',
        'fechamento de sacada São Paulo, envidraçamento de sacada SP, sacada articulada sem roldana, orçamento envidraçamento, vidro temperado sacada, NBR 7199'
      );
    }
  }, []);

  // Global WhatsApp click tracking for this page
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      const target = e.target as HTMLElement | null;
      if (!target) return;
      const link = target.closest('a[href*="wa.me"]');
      if (link) {
        GA_EVENT('whatsapp_click');
      }
    };
    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, []);

  return (
    <main className="min-h-screen font-sans">
      <HeroSection />
      <ProvaSocial />
      <Beneficios />
      <Comparativo />
      <OfertaCta />
      <Footer />
    </main>
  );
}